// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"f85d747a","498":"041be75d","703":"a58f37c9"}[chunkId] + ".chunk.js";
};